import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {
    mapViewReady$ = new Subject<__esri.MapView>();

    mapViewReady(mapView: __esri.MapView) {
        this.mapViewReady$.next(mapView);
    }
}
